 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		118: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = 'text/javascript';
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "static/js/" + ({"4":"trading"}[chunkId]||chunkId) + "." + {"0":"982a8e75","1":"a260dba2","2":"004f8f4a","3":"8d96d8dd","4":"ae4e7d72","5":"9f06494d","6":"9f6bb497","7":"1c8d2e3c","8":"3ca7d381","9":"8ab53bb5","10":"0c8381e3","11":"a673153a","12":"c22d5e39","13":"fe396078","14":"d1a0e523","15":"a23e26ee","16":"d1c09902","17":"852cdf41","18":"09ecbee3","19":"132d53d3","20":"54c07fdc","21":"238ad6bd","22":"cc9dbdd3","23":"4c8063f0","24":"cf2678fc","25":"7de14ab2","26":"3053a4b5","27":"29241f0e","28":"753b4de1","29":"f4a9680b","30":"07c7af9f","31":"5f4c19bf","32":"6dcbbcab","33":"4c0ca61a","34":"a1b8e79f","35":"cad78855","36":"7120db73","37":"84175f7f","38":"4bc449c5","39":"4d317282","40":"0881bafc","41":"b59f4512","42":"273ffa20","43":"c2be5435","44":"65781d37","45":"37ea9acb","46":"0d16e3e9","47":"fd35409d","48":"8c2a84ec","49":"84710584","50":"0f7b69a9","51":"f86b433a","52":"1f9b8dd1","53":"a5d3f81d","54":"a1ba183f","55":"f32489de","56":"44b54d9a","57":"4a655662","58":"95fc7e40","59":"22abead9","60":"499ff231","61":"c1451d63","62":"33fc89a2","63":"abb1cea8","64":"a45428a5","65":"846ce29e","66":"dbcd3c88","67":"e026422e","68":"dee4d101","69":"ac23a3cc","70":"01a457f8","71":"5671ce55","72":"8ff7916d","73":"36307b59","74":"b2921197","75":"d806372d","76":"b1506c4d","77":"7fee9a33","78":"10ec1682","79":"26412498","80":"f01fd10e","81":"512b0f3d","82":"8725847d","83":"3c9eaeb8","84":"71961612","85":"b915db9e","86":"fdbe3ff9","87":"41920653","88":"c2f799d4","89":"3ae3f7b6","90":"103388e3","91":"8c33345c","92":"03d73293","93":"badcb2f6","94":"7624a4b5","95":"011eeb3d","96":"23c4d1d0","97":"acd48ec1","98":"8a113b28","99":"af594a85","100":"0953d81d","101":"dcff260d","102":"e44bd3d4","103":"37decc00","104":"1e1d87c7","105":"57e0638b","106":"08a0512a","107":"604af00c","108":"fc084128","109":"d4098f38","110":"05810b84","111":"9ddc2bab","112":"ed470e0d","113":"2536edf5","114":"e75d23cc","115":"6a50729a","116":"ec488c11","117":"cc4725e2"}[chunkId] + ".chunk.js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// identity function for calling harmony imports with the correct context
 	__webpack_require__.i = function(value) { return value; };

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2793);



// WEBPACK FOOTER //
// webpack/bootstrap 0ea5eb7f94616aa581e8